import type { TranslationKeys } from '../localeType';

export const esES: TranslationKeys = {
  // All Pages
  addAccessories: 'Añadir más accesorios',
  all: 'Todos',
  checkAll: 'Seleccionar todo',
  anyFloristFounded: 'No se ha encontrado ninguna floristería',
  backToOrderList: 'Atrás',
  cancel: 'Cancelar',
  catalog: 'Catálogo',
  catalogAbroad: 'Catálogo de productos internacionales',
  closed: 'Cerrado',
  communications: 'Comunicación',
  date: 'Fecha',
  download: 'Descargar',
  downloadLabel: `Descargar etiqueta`,
  endDate: 'Fecha final',
  goToOrders: 'Accede a tus pedidos',
  goToOrder: 'Acceder al pedido',
  history: 'Historial',
  hour: 'Hora',
  inProgress: 'En curso',
  isModified: 'Modificado',
  isReady: 'Ramo listo',
  ITContact: 'Contacto Interflora',
  loginAs: 'Iniciado sesión como',
  modify: 'Modificar',
  new: 'Nuevo',
  noDocuments: 'No se encontraron documentos con estos filtros:',
  noOrderInTab: 'No hay pedidos en esta pestaña',
  noOrdersFound: 'Ningún pedido coincide con esta búsqueda',
  nothingFound: `Nada Encontrado`,
  open: 'Abierto',
  orderDefault: 'Pedido',
  orders: 'Pedidos',
  partner: 'Sitios asociados',
  price: 'Precio',
  startDate: 'Fecha de inicio',
  suspendedFlorist: 'Florista não ativo',
  to: 'hasta',
  and: 'y',
  today: 'Hoy',
  unknown: 'Desconocido',
  validate: 'Validar',
  save: 'Guardar',
  view: 'Vista',
  close: 'Cerrar',
  actionImpossible: 'No disponible',
  listView: 'Ver lista',
  listViewTooltip: 'Este botón permite mostrar la lista',
  mapView: 'Ver mapa',
  mapViewTooltip: 'Este botón permite mostrar el mapa',
  viewOnMap: 'Ver en el mapa',
  true: 'Sí',
  false: 'No',
  delete: 'Eliminar',
  warning: 'Atención',
  courierDeliveryOrderWarning: '¡Está actuando en un pedido previsto inicialmente para entrega por mensajero!',
  putOrderInProgress: 'Activación del estado En curso',
  removeOrderInProgress: 'Desactivación del estado En curso',
  actionUnavailable: 'Acción imposible',

  print: {
    title: 'Imprimir',
    titleQuick: 'Impresión rápida',
    printed: 'Impreso',
    printTooltip: 'Este botón permite imprimir los albaranes de pedido que aún no han sido impresos',
    printedError: 'Se ha producido un error, inténtelo de nuevo más tarde',
    printedErrorMessage: 'Algunos pedidos no se pueden imprimir.',
    partiallyPrinted: 'Algunas facturas no se pudieron imprimir.',
    nothingToPrint: 'No hay facturas para imprimir.',
    markAsPrint: 'El pedido ha sido marcado como impreso.',
    markAsPrintPlural: 'Los pedidos han sido marcados como impresos.',
    popup: {
      title: '¿Marcar como impreso?',
      titlePlural: '¿Marcar como impresos?',
      validate: 'Marcar como impreso',
      validatePlural: 'Marcar como impresos',
      cancel: 'No marcar',
      textQuickPrint: `Ha utilizado la impresión rápida. ¿Desea marcar estos pedidos como Impresos para evitar una reimpresión mediante la impresión rápida?`,
      textMultiSelect: `Ha solicitado la impresión de varios pedidos. ¿Desea marcarlos como Impresos para evitar una reimpresión mediante la impresión rápida?`,
      textSinglePrint: `¿Desea marcar el pedido cuyo albarán acaba de consultar como Impreso para evitar una reimpresión mediante la impresión rápida?`,
    },
  },

  markAsPrint: {
    validMarkAsPrint: 'Los pedidos han sido marcados como impresos.',
    validUnmarkAsPrint: 'Los pedidos han sido marcados como no impresos.',
    warning: 'Algunos pedidos no han podido cambiar de estado',
    undoMarkAsPrint: 'Eliminar el estado Impreso',
    undoUnmarkAsPrint: 'Restaurar el estado Impreso',
  },

  // Homepage
  message: {
    welcome: 'Bienvenido, {name} \ud83c\udf3b',
  },
  ordersHome: {
    today: 'Pedidos para Hoy',
    tomorrow: 'Pedidos para mañana',
    later: 'Pedidos para otro día',
    late: 'Pedidos atrasados',
  },
  orderHome: {
    today: 'Pedido para Hoy',
    tomorrow: 'Pedido para mañana',
    later: 'Pedido para otro día',
    late: 'Pedido atrasados',
  },
  linkNewsLabel: 'Ver todas las noticias',
  seeMore: 'Ver más',
  seeLess: 'Ver menos',
  seeHistory: `Ver histórico`,
  NoNotification: 'Sin notificaciones',
  explanation: {
    title: 'Introducción a IRIS',
    content: `Bienvenido a tu nueva plataforma del florista.
Queremos recordarte que esta no es la versión final, nuestro trabajo aún está en progreso.
Durante esta fase, tus comentarios son cruciales.
Queremos agradecerte de antemano tu comprensión y paciencia.`,
  },
  newCollectionHome: 'La colección del momento',

  // Nav
  nav: {
    admin: 'Mi cuenta',
    contact: 'Contacto',
    deliveries: 'Entregas',
    history: 'Historial',
    home: 'Home',
    internalUser: 'Usuario interno',
    orders: 'Ejecuciones',
    page: 'Mi Interflora',
    QrCode: 'Validación de pedido',
    signOut: 'Desconectar',
    transmissions: 'Transmisiones',
    faq: 'Feira de preguntas',
    xlFlorist: 'Florista XL',
  },

  // Orders
  details: {
    download: 'Descargar como PDF',
    delivered: 'Confirmar entrega',
    absent: 'Establecer como ausente',
    reassign: 'Reasignar',
    additional: 'Información adicional',
    accept: 'Aceptar',
    refuse: 'Rechazar',
    addInfo: 'Añadir notas',
    assignToCourier: 'Asignar a un mensajero',
    cancel: 'Cancelar pedido',
    customerErrorMessage: 'No se puede mostrar el albarán',
    cancelDelivery: 'Cancelar entrega',
    recipient: {
      title: 'Destinatario y detalles de entrega',
      label: {
        additionalStreetInfo: 'Complemento de dirección',
        address: 'Dirección',
        colivex: 'Entrega en la tumba',
        companyName: 'Lugar de entrega',
        contactName: 'Nombre del contacto',
        country: 'País',
        deceasedName: 'Nombre del fallecido',
        deliveryDate: 'Fecha de entrega',
        deliveryLocation: 'Lugar de entrega',
        deliveryMoment: 'Momento de entrega',
        deliveryTime: 'Hora de entrega',
        event: 'Evento',
        infos: 'Información adicional',
        instructions: 'Instrucciones',
        name: 'Nombre',
        phone: 'Teléfono',
        postalCode: 'Código Postal',
        prelimeryAgreement: 'Acuerdo Preliminar', //not used in Spain
        region: 'Provincia',
        town: 'Ciudad',
      },
    },
    order: {
      title: 'Detalles del pedido',
      label: {
        legacyOrderId: 'Nº de Pedido B2F',
        orderStatus: 'Estado del pedido',
        orderDate: 'Fecha de grabación',
        price: 'Total',
        deliveryCost: 'Desplazamiento',
        trackingCode: `Código de envío`,
      },
      status: {
        NEW_ORDER: 'Nuevo Pedido',
        ASSIGNED: 'Asignado',
        ACCEPTED: 'Aceptado',
        REFUSED: 'Rechazado',
        ASSIGNATION_NOT_POSSIBLE: 'Asignación no posible',
        NOT_PRINTED: 'No impreso',
        PRINTED: 'Impreso',
        IN_PROGRESS: 'En curso',
        INTERNAL_COURRIER: 'Mensajería Interna',
        EXTERNAL_COURRIER: 'Mensajería Externa',
        DELIVERED: 'Entregado',
        ABSENT: 'Ausente',
        CANCELLED: 'Anulado',
        SENT: 'Enviado',
        REASSIGN: 'Reasignado',
      },
      notes: {
        addNote: `Añadir nota`,
        addPhoto: 'Añade una foto',
        anythingElse: 'Añade tu nota',
        create: 'Crea una nota',
        delivery: 'Entrega',
        deliveryChanges: `¿Cambios en la entrega?`,
        deliveryDetail: 'Especificar los detalles de la entrega',
        emptyNoteList: `No tienes notas`,
        emptyPhotos: `No tienes fotos`,
        imageCategory: `Categoría de imagen`,
        notValidatedNote: 'No se ha podido actualizar el estado de este pedido',
        product: 'Producto',
        title: 'Añade tus notas',
        titleAddNotes: 'Añadir notas',
        titleSetAsDelivered: 'Validar una entrega',
        confirmSetAsDelivered: '¿Está seguro de que desea marcar los {count} pedidos seleccionados como entregados?',
        validatedNote: `La nota ha sido creada`,
        validatedOrderNote: 'El pedido ha sido validado',
        dragAndDrop: 'Arrastra y suelta tu imagen aquí',
        or: 'o',
        browseFiles: 'Buscar archivos',
        uploadPhoto: 'Subir foto',
        addPhotoOptionnal: 'Añadir una foto (opcional)',
      },
      delivery: {
        inProgress: {
          status: 'Estado de la entrega:',
          momentTitle: 'Fecha y hora: ',
          moment: '{date} - Entre {hour} y {hourPlusOne}',
          price: 'Precio:',
          from: 'por',
        },
        cancel: {
          title: 'Cancelar entrega',
          body: 'Esta acción cancelará el servicio de entrega externo asignado a este pedido.',
          bodyInternalDelivery: 'Esta acción anulará la entrega interna asignada a este pedido.',
          buttonSecondary: 'Abandonar',
          buttonPrimary: 'Confirmar',
        },
      },
      modifications: {
        title: 'Modified order details',
        tooltip: 'Click for updates',
        modalTitle: 'Updates',
        noChanges: 'Cannot display order modifications',
        markAsRead: 'Mark as read',
      },
      invoicePrintedLabel: {
        yes: 'Impresa',
        no: 'No impresa',
      },
      invoicePrintedTooltip: {
        yes: 'Este pedido ha sido impreso',
        no: 'Este pedido aún no ha sido impreso',
      },
      recipientSmsStatus: {
        sent: {
          label: 'SMS enviado',
          fullLabel: 'SMS enviado',
          tooltip: 'Se ha enviado un SMS de notificación al destinatario',
        },
        resent: {
          label: 'SMS reenviado',
          fullLabel: 'SMS reenviado',
          tooltip: 'El SMS de notificación se ha reenviado al destinatario',
        },
        expired: {
          label: 'SMS caducado',
          fullLabel: 'SMS caducado',
          tooltip: 'El SMS de notificación ha caducado',
        },
        validatedByPhone: {
          label: 'Validado por teléfono',
          fullLabel: 'Validado por teléfono',
          tooltip: 'El florista ha validado la entrega mediante una llamada telefónica',
        },
        validatedBySms: {
          label: 'Validado por SMS',
          fullLabel: 'Validado por SMS',
          tooltip: 'El destinatario ha validado la entrega a través del enlace del SMS',
        },
      },
      recipientSmsAction: {
        removeValidation: 'Quitar validación',
        resendSms: 'Reenviar SMS',
        validateByPhone: 'Marcar como validado por llamada telefónica',
      },
      recipientSmsActionHint: {
        temporaryUnavailable: 'El reenvío no está disponible temporalmente',
        smsAlreadyResent: 'El SMS ya ha sido reenviado',
      },
    },
    florist: {
      title: {
        executor: 'Florista Ejecutante',
        transmitter: 'Florista Transmisor',
      },
      label: {
        name: 'Nombre',
        id: 'Nº de asociado',
        Phone: 'Teléfono',
        Email: 'Correo electrónico',
        SecondEmail: 'Correo electrónico',
      },
    },

    ribbon: {
      title: 'Cinta',
      text: 'Texto de cinta: ',
    },

    buyer: {
      title: 'Detalles del cliente',
      label: {
        name: 'Nombre',
        phone: 'Teléfono',
        email: 'Correo electrónico',
      },
    },

    header: {
      productCode: 'Código de Producto',
      quantity: 'Cantidad',
      size: 'Talla',
      description: 'Descripción',
      price: 'Precio',
      image: 'Imagen',
      composition: 'Composición',
      moreProducts: 'Más productos',
      accessory: 'Complementarios',
    },
    message: {
      title: 'Tarjeta dedicatoria',
      label: {
        message: 'Mensaje',
        signature: 'Firma',
      },
    },
    additionalImages: 'Fotos guardadas',
    recipientNotes: {
      title: 'Notas del destinatario',
      cardTitle: 'Nota del destinatario',
      cardTitleModified: 'Nueva nota del destinatario',
      canBeLeft: 'El pedido puede dejarse sin supervisión.',
      cannotBeLeft: 'El pedido no puede dejarse sin supervisión.',
    },
  },

  // Transmissions
  transmission: {
    title: 'Transmisiones',
    new: 'Nueva Transmisión:',
    locale: 'Nacional',
    abroad: `Internacional`,

    table: {
      no: 'No.',
      id: 'Número de pedido',
      product: 'Producto',
      recipient: 'Destinatario',
      town: 'Ciudad',
      status: 'Estado',
      date: 'Fecha de grabación',
    },
    form: {
      deliveryAddressCemeteryWarning: `La dirección de entrega parece ser un cementerio, pero la opción 'Entrega en Tumba' no está seleccionada. ¿Desea continuar?`,
      cemetery: 'cementerio',
      sended: 'El formulario ha sido enviado exitosamente',
      notSended: 'El formulario no ha sido enviado',
      country: 'País',
      mandatoryFields: 'Campos Obligatorios',
      noProductsForCountry: 'No se encontraron productos para este país',
      freePrice: {
        title: 'Precio libre',
        low: 'Precio libre demasiado bajo',
        entry: 'Introduce un precio libre',
        from: 'Producto con precio libre posible desde',
        integer: `los céntimos no son aceptados por el sistema internacional`,
      },
      emailNotValid: 'Correo electrónico no válido. Ejemplo: %{email}',
      phoneNotValid: `Teléphono no válido`, //. Ejemplo: %{phone}
      delivery: {
        additionalStreetInfo: 'Información adicional de dirección',
        address: 'Dirección',
        addressComplement: 'información adicional',
        city: 'Ciudad',
        cityPostalCode: 'Código postal o ciudad',
        deliveryInstructions: 'Instrucciones de entrega',
        extra: 'Extra',
        feasible: '¡Es posible hacer este pedido!',
        foreignAddress: `Como no se pueden verificar las direcciones extranjeras, por favor introduzca la dirección más completa posible`,
        guarantee: '*Sólo el día está garantizado',
        isBillNeeded: `Necesita una factura`,
        isCeremony: '¿Es para una ceremonia?',
        no: 'No',
        notFeasible: '¡No hay coincidencia posible para este pedido!',
        notFound: ' Dirección no encontrada',
        place: 'Nombre del lugar',
        psm: 'Información personalizada del producto',
        slot: 'Franja de entrega',
        streetName: 'Nombre de Calle',
        streetNumber: 'Número de Calle',
        title: 'Detalles de Entrega',
        toGrave: 'Entregar en tumba',
        yes: 'Sí',
        zipCode: 'Código Postal',
        errorAddressAndLocality: `La dirección no coincide con el destino {locality} seleccionado arriba`,
        date: {
          title: 'Fecha de entrega',
          today: `Hoy`,
          tomorrow: 'Mañana',
          later: 'Otro día',
          selectedDate: 'Fecha seleccionada: ',
        },
      },

      productDetail: 'Detalle del producto',
      selectSize: 'Selecciona el Tamaño',
      orderType: {
        title: 'Tipo de orden',
        regular: 'Normal',
        funeral: 'Funeral',
      },
      contact: {
        additionalStreetInfo: 'Información adicional',
        address: 'Dirección',
        buyerTitle: 'Detalles del cliente',
        city: 'Código postal o Ciudad',
        companyName: 'Nombre de la empresa',
        contactTitle: 'Detalles del destinatario',
        deceased: 'Fallecido',
        email: 'Correo electrónico',
        firstName: 'Nombre',
        fiscalCode: 'Código fiscal',
        lastName: 'Apellidos',
        phone: 'Teléfono',
        title: 'Detalles de contacto',
        zipCode: 'Código Postal',
      },
      message: {
        title: 'Detalles de la tarjeta dedicatoria',
        message: 'Mensaje',
        signature: 'Firma',
      },
      accessory: {
        addAccessory: 'Añadir complementario',
        addMoreAccessories: 'Añadir más complementarios',
        changeAccessory: 'Cambiar',
        label: 'Complementario',
        noAccessory: 'Ningún complementario seleccionado',
        removeAccessory: 'Eliminar',
        select: 'Selecciona un complementario',
        title: 'Detalles de complementarios',
        needRibbonText: '¿Agregar una cinta?',
        ribbonText: 'Introduzca el texto para la cinta',
      },
      summary: {
        title: 'Resumen: ',
        productTotal: 'Total del producto:',
        accessoriesTotal: 'Total des accesorios:',
        deliveryCost: 'Desplazamiento:',
        total: 'Total: ',
        transmissionFormComplete: 'El formulario de transmisión está completo',
        stepper: {
          productDetails: 'Detalles del producto',
          deliveryAddress: 'Dirección de entrega',
          deliveryDate: 'Fecha de entrega',
          feasability: 'Viabilidad',
          recipientInfo: 'Información del destinatario',
          buyerInfo: 'Información del comprador',
          feasabilityOK: 'Pedido viable',
        },
      },
      assignation: {
        title: 'Asignación de ejecutante',
        select: `Por favor selecciona el tipo de asignación`,
        zone1: 'Principal',
        zone2: 'Reservar',
        zone3: 'Zona grande',
        displayZone3: 'Mostrar lista de ',
        automatic: 'Automático',
        manual: 'Manual',
        floristNumber: 'Número de asociado',
        floristNumberError: `El formato del número de asociado no es el esperado`,
        floristNumberSupporting: 'El número de asociado debe empezar por 00',
        validationCode: 'Código de validación',
        mandatoryValidationCode: 'Código de validación obligatorio para este producto',
        table: {
          floristName: 'Nombre del florista',
          phone: 'Teléfono',
          distance: 'Distancia',
          quality: 'Bono de calidad',
        },
      },
      color: {
        select: 'Selecciona un color',
        nbOfFlowers: 'Número de flores',
        price: 'Precio',
      },
      psp: {
        title: 'Pago',
        paymentOK: '¡Pago realizado con éxito! Ahora puede continuar con la transmisión.',
        paymentKO: 'Error en el pago',
        paymentLinkExprired: 'El enlace de pago ha caducado. Genere uno nuevo seleccionando el tipo de pago.',
        linkAlreadyExist:
          'Parece que ya ha generado un enlace de pago con tarjeta bancaria. Asegúrese de que el cliente no lo utilice nuevamente para evitar un pago duplicado.',
        linkTime: 'Tiempo restante antes de que expire el enlace de pago: {time}',
        paymentDone: 'Pago realizado, la transmisión se enviará automáticamente',
        selectPayment: {
          title: 'Seleccionar tipo de pago',
          cash: 'Efectivo',
          bankCard: 'Tarjeta bancaria',
        },
        paymentLink: {
          title: 'Elija cómo enviar el enlace de pago al cliente',
          otherTab: 'Abrir en una nueva pestaña',
          sms: 'Enviar SMS',
          QrCode: 'Generar código QR',
        },
        otherTab: {
          title: 'Enlace de pago en otra pestaña',
          explaination:
            'La página de pago se abre en una nueva pestaña para su cliente. Le informaremos cuando el pago se haya realizado o haya expirado para que pueda continuar.',
        },
        sms: {
          title: 'Enlace de pago por SMS',
          send: 'Enviar SMS',
          explaination:
            'Se ha enviado un enlace de pago al cliente por SMS. Le informaremos cuando el pago se haya realizado o haya expirado para que pueda continuar.',
          smsSendError: 'Se produjo un error al enviar el SMS',
          smsSendImpossible: `El envío del SMS es imposible`,
          paymentLinkMessage: 'Interflora le agradece su confianza. Aquí está el enlace para el pago de su pedido. ',
        },
        qrCode: {
          title: 'Enlace de pago mediante código QR',
          explaination:
            'El cliente puede escanear el código QR para acceder al enlace de pago. Una vez realizado o expirado el pago, le informaremos para que pueda continuar con la transmisión.',
        },
      },
    },
    quickCheck: {
      title: 'Verificar un destino',
      label: 'Seleccione un destino',
      notFeasible: 'Este destino no está disponible para la transmisión.',
      feasible: `Este destino está disponible para la transmisión. 
Haga clic en « Continuar con la transmisión » para acceder al formulario.`,
      accessForm: 'Continuar con la transmisión',
    },
  },

  // OrderList
  delivered: 'Entregado',
  absent: 'Ausente',
  seeDetails: 'Ver detalles',
  hideDetails: 'Ocultar detalles',
  order: {
    search: '¿Qué estás buscando?',
    searchTooltip: 'Este botón permite realizar una búsqueda de pedidos',
    loadingOrders: 'Cargando pedidos...',
    quickActions: {
      delivered: 'Confirmar entrega',
      assignToCourier: 'Asignar al mensajero',
      absent: 'Destinatario ausente',
      reassign: 'Reasignar',
      accept: 'Aceptar',
      refuse: 'Rechazar',
      clear: 'Opciones claras',
      tooLate: 'Demasiado tarde para aceptar',
      acceptAndPrint: 'Aceptar e imprimir',
      downloadCSV: 'Descargar CSV',
      print: 'Imprimir',
      noOrderSelected: 'Seleccione varios pedidos para realizar acciones en grupo',
      noOrderSelectedShort: 'Ningún pedido seleccionado',
      openToolbar: 'Abrir multi-selección',
      closeToolbar: 'Cancelar multi-selección',
      ordersSelected: '{nbOrders} pedidos seleccionados',
      acceptAll: 'Aceptar toda la selección',
      acceptAndPrintAll: 'Aceptar e imprimir',
      cancelDelivery: 'Cancelar entrega',
      feedback: {
        cancelDeliveryOK: `La entrega externa se ha cancelado con éxito y el pedido se ha movido a la pestaña de pedidos.`,
        cancelInternalDeliveryOK: `El envío interno se ha cancelado correctamente y el pedido se ha trasladado a la pestaña de pedidos.`,
        cancelDeliveryKO: `No se ha podido cancelar la entrega externa.`,
        cancelInternalDeliveryKO: `No es posible cancelar el envío interno.`,
      },
    },
    title: 'Lista de pedidos',
    noStatusBanner: {
      mainText: `{count} pedido cuyo final de franja horaria de entrega se acerca no tiene el estado "Entregado" o "Destinatario ausente". | {count} pedidos cuyo final de franja horaria de entrega se acerca no tienen el estado "Entregado" o "Destinatario ausente".`,
      subText: `Detrás de cada pedido, alguien espera saber si sus flores han llegado bien. ¿Ha pensado en actualizarlos?`,
    },
    table: {
      no: 'No.',
      deliveryDate: 'Fecha de entrega',
      deliveryTime: 'Franja de entrega',
      id: 'Número de pedido',
      product: 'Producto',
      price: 'Total',
      town: 'Ciudad',
      recipient: 'Destinatario',
      preparing: 'En curso',
      invoice: 'Recibí',
      actions: 'Acciones',
      deliveryService: 'Servicio de entrega',
      reason: 'Motivo',
      openDetail: 'Abrir detalle',
      closeDetail: 'Cerrar detalle',
      deliveryDetails: 'Detalles de entrega',
      address: 'Dirección',
      phone: 'Número de teléfono',
      goToOrderDetail: 'Ir a la página de detalle del pedido',
      instructions: 'Instrucciones de entrega',
    },
    modal: {
      refuse: {
        title: '¿Quieres rechazar este pedido?',
        reason: {
          reason1: 'El precio es demasiado bajo',
          reason2: 'Mi tienda esta cerrada',
          reason3: `No puedo entregar`,
          reason4: `No tengo este producto`,
        },
      },
      absent: {
        title: '¿Por qué no se pudo entregar el pedido? ',
        subtitle: '¿Por qué no se pudo entregar el pedido? ',
        reason: {
          DANOREP: 'Destinatario inaccesible',
          DADATEULT: 'El destinatario cambió la fecha de entrega',
          DAREFUS: 'El destinatario rechazó el pedido',
          DANOINFO: 'Faltan datos para entregar el pedido',
        },
      },
      reassign: {
        title: '¿Desea reasignar este pedido?',
        reason: {
          PCO: 'Faltan los colores obligatorios',
          PFO: 'Faltan las flores obligatorias',
          PL: 'No hay repartidor disponible',
          LL: 'Entrega demasiado lejana',
          RT: 'Recibido demasiado tarde',
          PAM: 'Sin existencias en la tienda',
        },
      },
      delivery: {
        title: 'Elige un servicio de envío',
        intro: 'Elige un servicio de envío para el pedido <b>{orderId}</b>.',
        introMultiOrders: 'Elige un servicio de entrega para los {count} pedidos.',
        deliveryCost:
          'Coste {deliveryService}({serviceAmount}) - Gastos de envío({itfAmount}) = De su bolsillo({totalPrice})',
        delay: 'Disponible en {noticePeriod}',
        availableImmediately: 'Disponible inmediatamente',
        includedDeliveryPrice: 'Incluido en el paquete de entrega',
        serviceUnavailable: 'Servicio no disponible',
        selectYourSlot: 'Elija la franja horaria',
        deliverOrder: 'Entregar el pedido {orderId}',
        deliveryInstructions: 'Cualquier cosa para facilitar la entrega',
        validated: `El pedido {orderId} ha sido enviado a {service} !\nCompruebe el estado de la entrega en la pestaña de entrega`,
        internalValidated: `El pedido se asigna a {username} y se traslada a la pestaña de envíos.`,
        internalMultipleOrdersValidated: `Los pedidos se asignan a {username} y se trasladan a la pestaña de envíos.`,
        errorOnValidation: 'Imposible crear una entrega para el pedido {orderId}',
        errorOnMultipleOrdersValidation: 'No se puede crear el envío de los pedidos.',
        dateTooFar: `La fecha de entrega propuesta está demasiado lejana. Le invitamos a intentarlo de nuevo en unos días.`,
      },
    },
    multiSelect: {
      delivered: {
        allDelivered:
          '{count} pedidos han sido marcados como entregados con éxito. Ahora se han movido al historial de pedidos.',
        someNotUpdated: 'Algunos de sus pedidos no se pudieron actualizar.',
        noneUpdated: 'Ninguno de los pedidos seleccionados ha cambiado de estado.',
      },
      accept: {
        all: '{count} pedidos han sido aceptados con éxito. Ahora se han movido a la pestaña de pedidos.',
        someNotUpdated: 'Algunos de sus pedidos no pudieron ser aceptados.',
        noneUpdated: 'Ninguno de los pedidos seleccionados ha sido aceptado.',
        waiting: 'Procesamiento en curso, por favor espere...',
      },
    },
    floristToggle: {
      changeStateTooltip: 'Cambiar el estado del pedido',
      backToInitial: 'Volver al estado inicial',
      initial: {
        label: 'Inicial',
      },
      inProgress: {
        label: 'En progreso',
      },
      ready: {
        label: 'Ramo listo',
        lockedHint: 'Disponible solo 2 horas antes de la franja de entrega',
      },
    },
  },

  // pager
  pager: {
    itemsPerPage: '{counter} / página',
  },

  // My page
  myPage: {
    title: 'Mi página',
    calendarManagement: 'Gestión del calendario',
    infoManagement: 'Información de la tienda',
    notFound: 'Información de la floristería no encontrada',
    accessories: {
      accessoriesAction: 'Disponibilidad',
      accessoriesList: 'Lista de complementarios',
      anyAccessory: 'Sin accesorios',
      title: 'Gestión de complementarios',
    },
    hours: {
      title: 'Horarios de apertura',
      changeOpeningHours: 'Cambia tu horario de apertura',
      closeAllDayButton: 'Cerrar todo el día',
      shopClosed: 'Tu tienda está cerrada este día',
      openButton: 'Abierto',
      addBreak: 'Añadir un descanso',
      removeBreak: 'Quitar el descanso',
      saveButton: 'Guardar',
      closingTime: 'Hora de cierre',
      openingTime: 'Hora de apertura',
      breakEnd: 'Fin de descanso',
      breakStart: 'Inicio de descanso',
    },
    exceptions: {
      headerTitle: 'Mis excepciones',
      the: 'El :',
      from: 'De:',
      new: 'Añadir una excepción',
      next: `Siguientes excepciones`,
      any: `Sin excepción`,
      title: 'Próximas excepciones',
      to: 'Para:',
    },
    calendar: {
      title: 'Resumen mensual',
      weeklyCalendar: {
        calendarModified: 'Su calendario ha sido modificado exitosamente',
        clickToChange: 'Haga clic para abrir o cerrar*',
        closed: `Cerrado`,
        closedAM: `Cerrado por la mañana`,
        closedPM: `Cerrado por la tarde`,
        editWeek: 'Edita tu horario semanal',
        open: `Abierto todo el día`,
        openAM: `Abierto por la mañana`,
        openPM: `Abierto por la tarde`,
        title: 'Calendario semanal',
      },
      massive: {
        title: 'Añadir excepciones masivas',
        years: 'Years',
        months: 'Meses',
        days: 'Días',
        morning: 'Morning',
        afternoon: 'Tarde',
        exceptionsSended: 'Excepciones enviadas correctamente',
        exceptionsNotSended: `Las excepciones no se pueden registrar`,
      },
    },
    quality: {
      bonus: 'Bono de calidad',
      note: 'Tu calificación',
      noteMini: 'Calificación mínima',
      noteMaxi: 'Calificación máxima',
      endPeriod: 'Fin de validez',
      explainationTitleToMM: 'Mi bono de calidad y Mis reasignaciones',
      explainationToMM: `Las secciones « Mi bono de calidad » y « Mis reasignaciones » aún no están disponibles en Iris.
Al hacer clic en los botones correspondientes, será redirigido a Mon magasin, donde están disponibles.`,
      claims: {
        deliveryDate: 'Fecha',
        orderId: 'Número de Pedido',
        productCode: 'Producto',
        reason: 'Motivo',
        explainationTitleToMM: 'La página « Seguimiento de mi rendimiento » está en construcción',
        explainationToMM: 'Pronto reunirá todos sus indicadores clave en un panel completo y mejorado.',
      },
      title: {
        general: 'General',
        advertissement: 'Publicidad / Promoción de la Marca',
        quality: 'Calidad del Servicio',
        availability: 'Disponibilidad',
        tools: 'Herramientas',
      },
    },
    noStock: 'Actualmente no tienes stock',
    supplies: {
      title: 'Suministros',
      seeCart: 'Ver y validar mi pedido',
      yourOrders: 'Sus pedidos',
      emptyCart: 'Vaciar el carrito',
      chooseSupplies: 'Elegir suministros',
      modifyChooseSupplies: 'Modificar y elegir los suministros',
      orderSupplies: 'Pedidos de suministros',
      explainationTitleToMM: 'Sus pedidos de suministros llegarán pronto a IRIS',
      explainationToMM: `Las secciones « Pedidos de suministros » y « Mis pedidos de suministros » aún no están disponibles en IRIS.
Al hacer clic en los botones correspondientes, será redirigido a Mon magasin, donde podrá consultar y gestionar sus pedidos de suministros.`,
      modal: {
        add: 'Agregar',
        freeArticles: 'Administrativos (gratuitos)',
        paidArticles: 'Técnicos - Interflora (de pago)',
        productCode: 'Referencia',
        image: 'Vista previa',
        label: 'Etiqueta',
        VTACode: 'Código IVA',
        price: 'Precio unitario',
        action: 'Acción',
      },
      panel: {
        cart: 'Mi carrito',
        emptyCart: 'Su carrito está vacío',
        total: 'Total : ',
        noOrders: 'No tiene ningún pedido',
      },
    },
    contact: {
      mail: 'Su correo electrónico',
      mail2: 'Su correo electrónico complementario',
      validationCode: 'Su código de validación',
      address: 'Su dirección',
      phone: 'Su número de teléfono',
    },
    networkContact: {
      title: 'Su animador de red',
      mail: 'Su correo electrónico',
      name: 'Su nombre',
      phone: 'Su número de teléfono',
      phoneAppointment: 'Reservar una cita telefónica',
    },
    exclusions: {
      title: 'Mis exclusiones',
      list: 'Mi lista de exclusiones',
      empty: 'No tienes exclusiones',
    },
    claims: {
      title: 'Mis reclamaciones',
      empty: '¡Felicidades! No tiene ninguna reclamación registrada en los últimos 12 meses',
    },
    reassignations: {
      title: 'Mis reasignaciones',
      empty: 'No tiene ninguna reasignación registrada en los últimos 6 meses',
    },
  },

  info: {
    addHolidaysKO: `No se puede agregar este período de cierre`,
    addHolidaysOK: `Periodo cerrado añadido correctamente`,
    delHolidaysKO: 'No se puede eliminar este período de cierre',
    delHolidaysOK: `Período de cierre eliminado correctamente`,
    documentKO: 'No se puede ver este documento',
    documentOK: 'El documento se abrió en otra ventana',
    pending: `Demanda en curso`,
    editField: 'Editar campo',
    nophone: 'Por favor agrega un número de teléfono',
    nosecondMail: 'Por favor agrega un un email',
    nopersonalCode: 'Por favor agrega un código personal',
    statusKO: 'No se puede actualizar el estado',
    statusOK: 'Estado actualizado',
    updatePersonalCodeKO: 'No se puede actualizar el código personal',
    updatePersonalCodeOK: 'Código personal actualizado',
    updatePhoneKO: 'No se puede actualizar el teléfono',
    updatePhoneOK: 'Teléfono actualizado',
    updateSecondEmailKO: `No se puede actualizar el correo electrónico`,
    updateSecondEmailOK: 'Correo electrónico actualizado',
    updateStockKO: `No se puede actualizar el stock`,
    updateStockOK: 'Stock actualizado',
    documentPending: '',
    postSupplyOK: 'Pedido enviado',
    postSupplyKO: 'Pedido imposible',
    duplicateHolidays: 'Ya hay un cierre previsto para este período.',
    photoUploadOK: 'Foto guardada',
    photoUploadKO: `No se puede guardar la foto`,
    photoUploadTooBig: `La foto es demasiado grande.
Por favor, sube una foto de menos de 5 MB.`,
    reassignOK: 'Pedido reasignado, será redirigido a la lista de pedidos',
    reassignKO: 'Reasignación imposible',
  },

  days: {
    initiale: { 1: 'L', 2: 'M', 3: 'M', 4: 'J', 5: 'V', 6: 'S', 0: 'D' },
    short: { 1: 'Lun', 2: 'Mar', 3: 'Mie', 4: 'Jue', 5: 'Vie', 6: 'Sáb', 7: 'Dom' },
    0: 'Lunes',
    1: 'Martes',
    2: 'Miércoles',
    3: 'Jueves',
    4: 'Viernes',
    5: 'Sábado',
    6: 'Domingo',
  },
  moment: {
    0: 'Mañana',
    1: 'Tarde',
    2: 'Sin preferencia',
    3: 'Noche',
    hour: {
      0: '10h-15h',
      1: '17h-21h',
      2: '10h-21h',
      3: '18h-21h',
    },
  },
  openingMoment: {
    0: 'Cerrado todo el día',
    1: 'Abierto por la mañana',
    2: `Abierto por la tarde`,
    3: 'Abierto todo el día',
    4: 'Día festivo',
    5: 'Día festivo regional',
    6: 'Día de apertura obligatoria',
  },
  dropdown: {
    label: {
      accessory: 'Elige tu complementario',
      bouquet: 'Elige el ramo',
      city: 'Introduce la Ciudad',
      country: 'Elige país',
      loginAs: 'Introducir código de floristería',
      mail: 'Introduce tu correo electrónico',
      messageContent: 'Introduce tu mensaje',
      noteCategory: 'Categoría de nota',
      photoCategory: 'Categoría de la foto',
      occasion: 'Elige la ocasión',
      select: 'Elige el motivo',
      selectCategory: 'Seleccionar categoría',
      receiveAnswerAt: 'Recibirás la respuesta en',
      time: 'Elige el horario de entrega',
      type: 'Elige el tipo',
      year: `Elige el año`,
      search: 'Buscar...',
      locality: 'Elija el destino',
    },
    code: {
      ALL: 'Todo',

      // OBJECT OF THE MESSAGE
      B2B: 'Pedidos comerciales B2B',
      CALL: 'Solicitud de llamada de un operador',
      CANCEL: 'Me gustaría cancelar mi pedido',
      CLAIM: 'Reclamaciones/disputas',
      HELP: ' Asistencia Iris',
      INDEMNITY: 'Preguntas sobre su declaración de compensación',
      INFO: `Necesito información para procesar un pedido`,
      QUALITY: 'Bono de calidad',
      SHOP1: 'Su tienda (eliminación/rescisión/nuevos datos de contacto))',
      SHOP2: 'Tu tienda (accesorios/letrero)',
      SUPPLY: 'Orden de suministro',

      // MOMENT
      0: 'Mañana',
      1: 'Tarde',
      2: 'Sin preferencia',
      AFTERNOON: 'Tarde',
      DAY: 'Sin preferencia',
      MORNING: 'Mañana',

      // EVENT
      BABY: 'Nacimiento',
      BIRTHDAY: 'Cumpleaños',
      CONGRATULATIONS: 'Felicidades',
      FUNERALS: 'Funerales',
      JUSTBECAUSE: 'Por placer',
      OTHER: 'Otra razon',
      WEDDING: 'Boda',
      WELLSOON: 'Que te mejores pronto',

      // MAIL REASONS
      ADMIN: 'Pregunta sobre mi administración',
      HARDWARE: 'Pregunta sobre un problema en el PC',
      INVOICEINCIDENT: 'Incidencia con facturas',
      ORDER: 'Pregunta sobre un pedido',
      ORDERINCIDENT: 'Incidencia con pedido',
      ORDERMATERIAL: 'Solicitar material',
      PARTNER: 'Pregunta sobre mi sociedad',
      SUGGESTION: 'Realizar una sugerencia',

      // DOCUMENTS
      IT_DOC_ORDER_CART: 'Carrito de pedido',
      IT_DOC_ORDER_RECEIVER: 'Recibí de pedido',
      IT_DOC_ORDER_SENDER: 'Orden de compra del cliente',
      IT_INVOICE_BALANCE: 'factura de saldo(2024)',
      IT_INVOICE_PURCHASE: 'Factura de compra(2024)',
      IT_INVOICE_VENDOR: 'Factura del proveedor(2024)',
      SP_INVOICE_COMMISSIONS_RECTIFY: 'Factura de rectificación de comisiones',
      SP_INVOICE_COMMISSIONS: 'Facturas de honorarios/comisiones de compra para floristas',
      SP_INVOICE_EXECUTIONS_RECTIFY: 'Facturas de compra correctivas de ejecuciones',
      SP_INVOICE_EXECUTIONS: 'Facturas de ejecución de compra',
      SP_INVOICE_EXTRACT: 'Documento recapitulativo de compensación',
      SP_INVOICE_MATERIAL: 'Factura de material',
      SP_INVOICE_QUOTAS: 'Facturas de honorarios/comisiones de floristas',
      SP_INVOICE_CSI_SALES: 'Factura (pedidos completados)',
      SP_INVOICE_QUOTAS_RECTIFY: 'Cuotas de facturación rectificadas',
      PT_SAFT: 'Saft',
    },
  },

  notification: {
    title: 'Notificaciones',
    label: {
      order: 'Nuevo pedido',
      orderPlural: 'Nuevos pedidos',
      transmission: 'Transmisión',
      transmissionPlural: 'Transmisiones',
      review: 'Revisar',
      reviewPlural: 'Revisiones',
      modification: 'Modificación',
      modificationPlural: 'Modificaciones',
      cancellation: 'Cancelación',
      cancellationPlural: 'Cancelaciones',
      refused: 'Pedido rechazado',
      refusedPlural: 'Pedidos rechazados',
      expired: 'Pedido expirado',
      expiredPlural: 'Pedidos expirados',
    },
    message: {
      hideNotification: 'Ocultar notificación',
      more: 'Ver más',
      orderPlural: 'Ver lista de pedidos',
      transmissionPlural: 'Ver lista de transmisiones',
      reviewPlural: 'Ver reseñas',
      modificationPlural: 'Ver lista de pedidos',
      cancellationPlural: 'Ocultar notificación',
      refusedPlural: 'Ocultar notificación',
      expiredPlural: 'Ocultar notificación',
    },
    markAllAsRead: 'Marcar todo como leído',
  },

  mail: {
    from: 'Mensaje del florista: ',
    subject: 'Asunto: ',
    body: 'Mensaje: ',
    sended: 'Email enviado',
    notSended: `Error al enviar correo electrónico`,
  },

  billing: {
    notAllowed: 'No estás autorizado a ver esta información',
    header: {
      id: 'Número',
      date: 'Fecha',
      numberOfTransmission: 'Número de transmisiones',
      amount: 'Cantidad',
      type: 'Tipo',
      file: 'Archivo',
    },
  },
  filter: {
    all: 'Todos',
    today: 'Para Hoy',
    tomorrow: 'Para Mañana',
    later: 'Para otro día',
    past: 'Anteriores',
    toPrepare: 'Entregas Pendientes',
    inDelivery: 'En Reparto',
    absent: 'Ausente',
    toAccept: 'Pendientes de Aceptar',
    inProgress: 'En curso',
    late: 'Entregas Atrasadas',
    delivered: 'Entregado',
    activity: 'Mi Actividad',
    financial: 'Mis compensaciones',
    profiles: 'Mis mensajeros',
    activCourier: 'Mensajeros activos',
    inactivCourier: 'Mensajeros inactivos',
    allCourier: 'Todos los mensajeros',
    legal: 'Documentos legales',
    manageStore: 'Administrar mi tienda',
    bonus: 'Bono de calidad',
    customer: 'Albarán del cliente',
    executingForm: 'Formulario de pedido de ejecución',
    IT_DOC_ORDER_CART: 'Carrito de pedido',
    IT_DOC_ORDER_RECEIVER: 'Recibí de pedido',
    IT_DOC_ORDER_SENDER: 'Orden de compra del cliente',
    IT_INVOICE_BALANCE: 'factura de saldo(2024)',
    IT_INVOICE_PURCHASE: 'Factura de compra(2024)',
    IT_INVOICE_VENDOR: 'Factura del proveedor(2024)',
    SP_INVOICE_COMMISSIONS_RECTIFY: 'Factura de rectificación de comisiones',
    SP_INVOICE_COMMISSIONS: 'Facturas de honorarios/comisiones de compra para floristas',
    SP_INVOICE_EXECUTIONS_RECTIFY: 'Facturas de compra correctivas de ejecuciones',
    SP_INVOICE_EXECUTIONS: 'Facturas de ejecución de compra',
    SP_INVOICE_EXTRACT: 'Documento recapitulativo de compensación',
    SP_INVOICE_MATERIAL: 'Factura de material',
    SP_INVOICE_QUOTAS: 'Facturas de honorarios/comisiones de floristas',
    SP_INVOICE_CSI_SALES: 'Factura (pedidos completados)',
    SP_INVOICE_QUOTAS_RECTIFY: 'Cuotas de facturación rectificadas',
    PT_SAFT: 'Saft',
  },

  size: {
    label: 'Selecciona el tamaño',
    0: 'U',
    1: 'S',
    2: 'M',
    3: 'L',
    4: 'Precio libre',
    Standard: 'Estándar',
    Premium: 'Premium',
    Deluxe: 'Deluxe',
    one_size: 'U',
    small: 'S',
    medium: 'M',
    large: 'L',
    null: 'Depende del precio',
    Normal: 'S',
    Grande: 'M',
    Superior: 'L',
    Pequeño: 'S',
    Médio: 'M',
    Médium: 'M',
    Petit: 'S',
  },

  deliveryMode: {
    CEREMONY: 'Ceremonia',
    NO_ADDRESS: `Sin dirección`,
    SELF: 'Por sí mismo',
    STANDARD: 'Estándar',
    TOMB: 'Funeral',
    FUNERAL_PLACE: 'Funeral',
    GRAVE: 'Funeral',
  },

  error: {
    floristUnknown: {
      title: 'Identificador desconocido',
      body: `La cuenta actual no es válida: presione el botón de desconexión y elija otra cuenta.`,
      button: 'Desconectarse',
    },
    noCountryCode: {
      title: 'Código de país desconocido',
      body: `Código de país desconocido: haga clic en el botón cerrar sesión y elija otra cuenta.`,
      button: 'Desconectarse',
    },
  },

  soon: {
    kpi: `Próximamente, encuentre los KPI de su empresa aquí`,
    hourly: 'Próximamente, encuentra tu horario de apertura aquí',
  },

  color: {
    blue: 'Azúl',
    green: 'Verde',
    mixed: 'Multicolor',
    orange: 'Naranja',
    pink: 'Rosa',
    purple: 'Púrpura',
    red: 'Rojo',
    silver: 'Plata',
    white: 'Blanco',
    yellow: 'Amarillo',
  },

  multiproducts: 'productos',
  QrCode: {
    200: 'El pedido ha sido entregado',
    400: 'No se puede establecer el estado del pedido como entregado',
    500: 'Se ha producido un error, póngase en contacto con Interflora',
  },

  internalUser: {
    any: 'No hay floristería seleccionada',
    backToAdmin: 'Volver al área de administrador',
    loggedIn: 'Has iniciado sesión como',
    login: 'Iniciar sesión',
    needId: 'Debes estar conectado a una floristería para ver esta información',
    placeholder: 'Introducir código de florista',
    title: 'Entrar como',
  },

  // DELIVERY STATUSES
  deliveryStatus: {
    scheduled: 'Programada',
    booked: 'Encargado',
    pending: 'Buscando repartidor',
    picking: 'Repartidor en ruta',
    almost_picking: 'Repartidor cerca',
    waiting_at_pickup: 'Esperando recogida',
    delivering: 'En entrega',
    almost_delivering: 'Cerca del lugar de entrega',
    waiting_at_dropoff: 'Esperando entrega',
    delivered: 'Entregado',
    no_courier_available: 'No hay mensajero disponible',
    cancelled: 'Entrega cancelada',
  },

  calendarExceptionType: {
    CountryForceOpen: 'Apertura obligatoria',
    CountryHolidays: 'Vacaciones del país',
    DefaultDates: 'Abierto',
    FloristCloseOnlyAfternoon: 'Cerrado sólo por la tarde',
    FloristCloseOnlyMorning: 'Cerrado sólo por la mañana',
    FloristHoliday: 'Vacaciones',
    FloristOpenOnlyAfternoon: 'Abierto sólo por la tarde',
    FloristOpenOnlyMorning: 'Abierto sólo por la mañana',
    FloristOpenWholeDay: 'Abierto',
    RegionalHoliday: 'Fiesta regional',
  },

  month: {
    1: 'Ene',
    2: 'Feb',
    3: 'Mar',
    4: 'Abr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Ago',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dic',
  },
  lastsMonth: 'Últimos 12 meses',
  kpi: {
    labelBestSeller: 'Número de ventas',
    labelExecution: 'Monto de las ejecuciones',
    labelNPS: 'NPS',
    labelNumberOfRefusal: 'Número de rechazos',
    thisMonth: 'Este mes',
    titleBestSeller: 'Tus más vendidos',
    titleExecution: 'Mis ejecuciones',
    tooltipExecution: `Número de ejecuciones`,
    noDataPeriod: 'No hay datos para este periodo',
    month: {
      0: 'Ene',
      1: 'Feb',
      2: 'Mar',
      3: 'Abr',
      4: 'May',
      5: 'Jun',
      6: 'Jul',
      7: 'Ago',
      8: 'Sep',
      9: 'Oct',
      10: 'Nov',
      11: 'Dic',
    },
  },

  locality: {
    FR: 'France Métropolitaine',
    CORSE: 'Corse',
    DOMTOM: 'Drom-Com',
  },

  compensation: {
    explanation: '',
    title: 'Mi compensación para ',
    fortnight: {
      1: 'Primera quincena',
      2: 'Segunda quincena',
    },
    login: {
      title: 'Acceso restringido',
      secretCode: 'Código secreto:',
      placeholder: '12345',
      error: 'Código secreto incorrecto',
    },
    recette: {
      download: 'Download results of',
    },
  },

  capping: {
    title: `Capacidad de ejecución`,
    adjustCapping: 'Ajustar el límite de capacidad',
    daysBeforeEvent: `El evento tendrá lugar en {count} día{plural}`,
    needToBeSuperior: `Durante este período no es posible reducir el límite por debajo de {minCapping}. Por favor, ajusta el valor.`,
    ordersLeft: `¡Quedan {ordersLeft} pedidos antes de alcanzar el límite! Puedes considerar aumentar el límite máximo.`,
    noOrdersLeft: `Ha alcanzado su capacidad máxima de ejecución. Puede considerar aumentar el límite máximo.`,
  },

  xlPage: {
    productsStock: {
      action: 'Acción de productos',
      list: 'Lista de productos',
      anyProduct: 'Sin productos',
      title: 'Gestión de productos',
      selection: {
        flower: 'Flores',
        gift: 'Regalos',
      },
    },
  },

  internalCourier: {
    createNewCourier: 'Añadir un mensajero',
    undefined: 'No definido',
    list: {
      headerTable: {
        courierProfile: 'Repartidor',
        courierId: 'Identificación del repartidor',
        activationDate: 'Fecha de activación',
        deactivationDate: 'Fecha de desactivación',
        actions: 'Acciones',
      },
      statusSrOnly: {
        active: 'Perfil de repartidor activo',
        inactive: 'Perfil de repartidor inactivo',
      },
      toggleStatus: {
        active: 'Activar perfil',
        inactive: 'Desactivar el perfil',
      },
      edit: 'Modificar el perfil',
      empty: {
        title: 'Aún no se ha creado ningún perfil de repartidor.',
        text: 'Los perfiles de repartidor te permiten asignar los pedidos a tus repartidores internos.',
      },
    },
    create: {
      couriersInformation: 'Información del mensajero',
      title: 'Crear un perfil de mensajero',
      name: 'Nombre del mensajero*',
      nameAlreadyExistMessage: 'Este nombre ya está en uso. Añade algo (por ejemplo un número) para que sea único.',
      id: 'Identificador de acceso del mensajero',
      idExplaination:
        'El identificador permite a este perfil conectarse a Iris. Se crea automáticamente a partir del nombre introducido y de la información de su tienda para ser único.',
      profileCreated: 'El mensajero ha sido creado.',
      profileNotCreated: 'Imposible crear el mensajero',
      password: {
        label: 'Contraseña*',
        confirmLabel: 'Confirmar contraseña*',
        confirmNotMatch: 'Los dos campos no coinciden.',
        rules: {
          uppercase: 'Una mayúscula',
          lowercase: 'Una minúscula',
          number: 'Un número',
          minCaracters: 'Más de 10 caracteres',
          specialCaracters: "Un carácter especial entre ? ! - _ & % {'@'}",
        },
      },
      status: {
        title: 'El estado del mensajero',
        explanation: {
          activation: {
            default: `El mensajero estará activo desde el día de activación seleccionado.`,
            inactiv: 'El mensajero estará inactivo.',
          },
          desactivation: {
            default: `El mensajero estará inactivo desde el día de desactivación seleccionado.`,
            notDefine: `El mensajero permanecerá activo hasta que lo desactive.`,
          },
          tomorrowTooltip: `La fecha de desactivación no puede ser anterior a la fecha de activación.`,
        },
      },
      date: {
        activationTitle: `Fecha de activación*`,
        desactivationTitle: 'Fecha de desactivación*',
        today: `Hoy`,
        tomorrow: 'Mañana',
        otherDate: 'Otra fecha',
        notDefine: 'No definido',
        endDateBeforeStartDate: 'La fecha de desactivación no puede ser anterior a la fecha de activación.',
      },
      error: {
        someFieldsNeedCorrection: 'Cierta información debe ser corregida. Por favor, comprueba los campos señalados.',
        someFieldsAreMissing: 'Falta cierta información. Por favor, comprueba los campos señalados.',
        fieldRequired: 'Este campo es obligatorio.',
        impossibleToCreate: 'Imposible crear el perfil del repartidor.',
      },
    },
    update: {
      title: 'Editar un perfil de mensajero',
      profileUpdated: 'El mensajero ha sido actualizado.',
      selectedCourier: 'El repartidor seleccionado',
      cancelButton: 'Mantener la planificación',
      activationButton: 'Activar',
      deactivationButton: 'Desactivar',
      password: {
        edit: 'Editar contraseña',
        label: 'Nueva contraseña*',
        closeWithoutSaving: 'Cerrar sin guardar',
      },
      error: {
        impossibleToUpdate: 'Imposible actualizar el perfil del repartidor.',
      },
      guidingMessage: {
        activation: '¡Parece que ya se ha programado una activación para este correo!',
        deactivation: '¡Parece que ya se ha programado una desactivación para este correo!',
        activationDate: 'Fecha prevista de activación:',
        deactivationDate: 'Fecha prevista de desactivación:',
        profileDeactivate: 'El mensajero ha sido desactivado correctamente',
        profileActivate: 'El mensajero ha sido activado correctamente',
        disableActions:
          'Para modificar el periodo de actividad o eliminar a este repartidor, primero debes retirar los pedidos asociados a él.',
      },
      modalTitle: {
        deactivation: 'Desactivar el repartidor',
        activation: 'Activar el repartidor',
      },
    },
    delete: {
      title: 'Eliminar un perfil de repartidor',
      button: 'Eliminar este repartidor',
      bodyTitle: '¿Estás seguro/a de que quieres eliminar este repartidor definitivamente?',
      profileDeleted: 'El repartidor ha sido eliminado correctamente.',
      error: {
        impossibleToUpdate: 'Imposible eliminar el perfil del repartidor',
        activeOrders:
          'Este repartidor todavía tiene pedidos activos en curso. Cancela o reasigna esos pedidos desde la pestaña «Entrega» y, a continuación, vuelve a intentarlo.',
      },
    },
    deliveryTab: {
      isActiv: 'Interno',
      isInactiv: 'Repartidor inactivo',
    },
    assignation: {
      title: 'Entrega interna',
      activeProfiles: '{n} perfil activo el día de la entrega',
      activeProfilesPlural: '{n} perfiles activos el día de la entrega',
      noActiveProfiles: 'No hay repartidores disponibles',
      goToInternalCourierList: 'Abrir la gestión de repartidores',
    },
    detail: 'Pedido gestionado internamente',
  },
  onboarding: {
    title: 'Tutorial',
    checkLater: 'Recordar más tarde',
    close: 'Cerrar',
    startGuide: 'Empezar',
    next: 'Siguiente',
    finishGuide: 'Entendido',
    readTime: 'Tiempo estimado: {minutes} min',
    recipientConfirmation: {
      welcome: {
        title: 'Tutorial - Novedades',
        description: [
          'Hemos añadido nuevas herramientas a tu interfaz para facilitarte el seguimiento de tus pedidos y entregas. ¡Déjate guiar para descubrir cómo funcionan!',
          'Las novedades:',
          '1. SMS al destinatario',
          '2. Foto en la entrega',
          '3. Mejoras de visualización',
        ].join('\n'),
      },
      step1: {
        title: 'Envío del SMS al destinatario',
        description: [
          'El destinatario recibe automáticamente un SMS <strong>en el que se le pide que confirme sus datos y su presencia en la fecha y franja horaria solicitadas.</strong>',
          'Envío del SMS: la víspera de la entrega a las 18:00 o 30 min después de la compra para los pedidos realizados el mismo día.',
          '<br />',
          'Ahorra tiempo: si el destinatario ha confirmado, ¡no hace falta llamarlo antes de salir a repartir!',
          'Si no, realiza la entrega como lo haces hoy.',
        ].join('\n'),
      },
      step2: {
        title: 'Estados del SMS',
        description: [
          'El SMS puede tener varios estados:',
          '1- "Validado" por SMS - todo está bien, el icono se vuelve verde',
          'Una vez validado, el destinatario ya no puede modificar esta información.',
          '2- "Validado" por teléfono - Has hablado con el destinatario por teléfono, valida el estado manualmente',
          '3- "Enviado" - el SMS se ha enviado',
          '4- "Reenviado" - reenvía el SMS con un clic para darle al destinatario una segunda oportunidad de confirmar.',
          '5- "Caducado" - sin respuesta 1 h antes del final de la franja horaria de entrega, el destinatario ya no puede añadir información ni validar -> realiza la entrega como lo haces hoy',
        ].join('\n'),
      },
      step3: {
        title: 'Nuevo estado "Listo"',
        description: [
          'Una vez terminada la preparación del producto, pon el pedido en estado "Listo" en iris: estás listo para entregarlo.',
          'Nota: ',
          '- una vez activado el estado "Listo", el destinatario ya no puede añadir información',
          '- este estado está disponible el día de la entrega, desde 2 h antes del inicio de la franja horaria de entrega',
        ].join('\n'),
      },
      step4: {
        title: 'Actualizaciones de la información del pedido',
        description: [
          'Si el destinatario añade detalles o si se modifica el pedido, aparece el icono «i» morado.',
          'Accede con un clic al historial de modificaciones de un pedido.',
          'Haz clic en el icono «i» desde la lista de pedidos para ver qué ha cambiado y marcar la modificación como vista.',
          'Esta información sigue disponible en cualquier momento.',
        ].join('\n'),
      },
      step5: {
        title: 'El destinatario acepta la entrega en su ausencia',
        description: [
          'El destinatario puede autorizar que se deje el pedido en su ausencia, con posibles indicaciones adicionales. Ej.: con el vecino, delante de la puerta, detrás de la verja a la derecha...',
          'Encuentra esta información en la página de detalle del pedido o mediante el icono «i»',
          'En este caso concreto, <strong>se requiere una foto en el momento de la entrega, sin rostros visibles. Te protege en caso de litigio.</strong>',
        ].join('\n'),
      },
      step6: {
        title: '¿Cómo hacer la foto?',
        description:
          'Cuando confirmas la entrega, aparece una pantalla. Recuerda desplazarte hacia abajo con la barra lateral para que aparezca la opción FOTO',
      },
      step7: {
        title: 'Seguimiento de impresiones',
        description: 'Desde la lista de pedidos, comprueba de un vistazo si tus pedidos han sido impresos.',
      },
      step8: {
        title: 'Colores de estado más visibles',
        description:
          'Se ha reforzado el color en ciertas zonas de las líneas de pedido para distinguir mejor los estados, sin sobrecargar la lectura del resto de la línea.',
      },
    },
  },
};
